module.exports = __webpack_public_path__ + "img/faq-easy.9c656c9.svg";